import React, {useEffect, useState} from "react"
import {CheckoutExtraOperationsFilters, usePaginatedCheckoutExtraOperations} from "../utils/hooks/usePaginatedCheckoutExtraOperations.ts";
import {useIntersect} from "../utils/hooks/useIntersect.ts";
import {formatDate, formatPrice, Schema} from "../utils";
import {Loader} from "./Loader.tsx";
import {useCore} from "../hooks";

export const CheckoutDetailExtraOperationsList: React.FC = () => {
  const { selectedDetailCheckoutId, currency, checkouts } = useCore()
  const selectedCheckout = checkouts?.find(c => c.id === selectedDetailCheckoutId)
  const { measureRef, isIntersecting } = useIntersect()
  const [filters, setFilters] = useState<CheckoutExtraOperationsFilters>({
    checkouts: [Number(selectedDetailCheckoutId)],
  })

  const filter = () => {
    setFilters({
      checkouts: [Number(selectedDetailCheckoutId)],
    })
  }

  const clearFilters = () => {
    setFilters({
      checkouts: [Number(selectedDetailCheckoutId)],
    })
  }

  const { refresh, checkoutExtraOperations, loading, loadMore, isLastPage, totalCount } = usePaginatedCheckoutExtraOperations({
    filters: {
      ...filters
    },
    sort: 'id',
    direction: 'DESC',
    schema: Schema.checkoutExtraOperation.list,
  })

  useEffect(() => {
    if (isIntersecting) {
      loadMore()
    }
  }, [isIntersecting])

  useEffect(() => {
    filter()
  }, [selectedDetailCheckoutId])

  return (
    <div>
      <div className="overflow-x-auto">
        <table className="table table-zebra w-full">
          <thead>
            <tr>
              <th className="text-left">POKLADNA</th>
              <th className="text-left">DATUM VYTVOŘENÍ</th>
              <th className="text-left">ČÁSTKA</th>
              <th className="text-left">POZNÁMKA</th>
              <th className="text-left">UŽIVATEL</th>
            </tr>
          </thead>
          <tbody>
            {checkoutExtraOperations?.length > 0 ? checkoutExtraOperations.map(extraOp => {
              // Use checkout from extraOp if available, otherwise use selectedCheckout (since we filter by selectedDetailCheckoutId)
              const checkoutName = extraOp.checkout?.name || selectedCheckout?.name || ''
              return (
              <tr key={`extraOp-row-${extraOp.id}`}>
                <td>{checkoutName}</td>
                <td>{extraOp.dateCreated?.length ? formatDate(new Date(extraOp.dateCreated), false, true) : ''}</td>
                <td className="font-bold">{formatPrice(extraOp.amount || 0, currency.id)}</td>
                <td>{extraOp.note}</td>
                <td>{extraOp.user?.email || ''}</td>
              </tr>
              )
            }) : (
              <tr>
                <td colSpan={5} className="text-center py-4">
                  {loading ? <Loader /> : <span className="text-base-400">žádné operace</span>}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {!isLastPage && (
        <div ref={measureRef} className="text-center py-4">
          <span className="text-base-400">next page..</span>
        </div>
      )}
    </div>
  )
}
